<template>
  <b-dropdown
    v-model="selectedValue"
    :data="dropdownList"
    multiple
    ref="dropdown"
    aria-role="list"
    :scrollable="true"
  >
    <template slot="trigger">
      <button class="button dropdown-button" type="button">
        <span v-if="selectedValue.length > 0"
          >{{ inputBoxText }} ({{ selectedValue.length }})</span
        ><span v-else>{{ inputBoxText }}</span>
        <b-icon icon="menu-down"></b-icon>
      </button>
    </template>
    <b-dropdown-item custom aria-role="listitem">
      <label class="b-checkbox checkbox">
        <input
          type="checkbox"
          v-model="allSelected"
          @input="selectedValue = selectAll(dropdownList)"
        />
        <span class="check select-checkbox"></span>
        <span class="control-label">
          <span class="select-all-label">Select all</span>
        </span>
      </label>
    </b-dropdown-item>
    <b-dropdown-item
      custom
      aria-role="listitem"
      v-for="(option, index) in dropdownList"
      :key="index"
    >
      <label class="b-checkbox checkbox">
        <input
          type="checkbox"
          v-model="selectedValue"
          :value="option"
          @input="customItem(selectedValue, dropdownList, option)"
        />
        <span class="check"></span>
        <span class="control-label">
          <span>{{ option.name }}</span>
        </span>
      </label>
    </b-dropdown-item>
  </b-dropdown>
</template>
<script>
export default {
  name: "CustomDropdown",
  props: {
    dropdownList: [],
    inputBoxText: {
      type: String,
      default: "Select"
    },
    preSelectedValue: null,
    isCountry: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedValue: this.dropdownList,
      allSelected: true,
      initialValue: true
    };
  },
  methods: {
    customItem(arr, status, value) {
      this.allSelected = false;
      let col = arr;
      col.includes(value)
        ? (col = col.filter(item => item !== value))
        : col.push(value);
      if (col.length === status.length) {
        this.allSelected = true;
      }
      if (col.length > 0) {
        //this.enableSearch();
      }
      return col;
    },
    selectAll(values) {
      let arr = [];
      if (this.allSelected === true) {
        arr = [];
        this.allSelected = false;
      } else {
        this.allSelected = true;
        values.forEach(element => {
          arr.push(element);
        });
      }
      return arr;
    }
  },
  watch: {
    selectedValue(newValue) {
      if (!this.initialValue) {
        this.$emit("valueSelected", [newValue, this.isCountry]);
      } else {
        this.initialValue = false;
      }
    },
    dropdownList(newValue) {
      this.selectedValue = newValue;
      this.allSelected = true;
    },
    preSelectedValue(newValue) {
      this.selectedValue.length > 1 ? (this.allSelected = false) : "";
      this.selectedValue = newValue;
    }
  }
};
</script>
